import React from 'react';
import './Footer.css';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-text">
            <p>&copy; {currentYear} MASAR. {t.footer.rights}</p>
          </div>
          <div className="footer-links">
            <a href="#hero">{t.nav.home}</a>
            <a href="#projects">{t.nav.portfolio}</a>
            <a href="#about">{t.nav.about}</a>
            <a href="#contact">{t.nav.contact}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

